import {bindActionCreators} from 'redux';
import {createStructuredSelector} from 'reselect';
// selectors
import {
  getProductNote,
  getSelectedProductId,
  showSleevePrintRepImageryNote
} from '~/selectors/ProductSelectors';
// actions
import {
  productPrintArea,
  sleevePrintPriceInfo
} from '~/actions/AnalyticsActions';

export const select = () => {
  return createStructuredSelector({
    note: getProductNote,
    productId: getSelectedProductId,
    showSleevePrintRepImageryNote: showSleevePrintRepImageryNote
  });
};

export function actions(dispatch) {
  return bindActionCreators(
    {
      onToggleNote: productPrintArea,
      sleevePrintPriceInfo
    },
    dispatch
  );
}
